var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column-container"},[(_vm.currentResource.config().timetravel())?_c('time-travel'):_vm._e(),_c('asset-summary'),_c(_vm.bannerComponent(_vm.currentResource),{tag:"component",attrs:{"resource":_vm.currentResource}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }